import { Box, Stack } from '@mui/material';

import { radius } from '@karehero/llama/theme/radius';

/**
 * The three dots, in the bubble the answer is about to arrive in.
 *
 * Same surface and same corners as a message from Keni, because that is what it
 * is standing in for: the bubble appears, then its contents. Anything else and
 * the answer lands in a shape that was not there a moment ago.
 *
 * Keyframes are declared in sx so the animation travels with the component, the
 * way KeniOrb does it.
 */
const ChatTyping = () => (
  <Stack
    sx={{
      alignSelf: 'flex-start',
      alignItems: 'center',
      px: 2,
      py: 1.75,
      bgcolor: 'background.paper',
      border: 1,
      borderColor: 'custom.neutral.200',
      borderRadius: `${radius.lg}px`,
      borderBottomLeftRadius: '4px',
      '@keyframes chat-typing': {
        '0%, 60%, 100%': { opacity: 0.25, transform: 'translateY(0)' },
        '30%': { opacity: 1, transform: 'translateY(-3px)' },
      },
    }}
    direction='row'
    spacing={0.75}
  >
    {[0, 1, 2].map((i) => (
      <Box
        key={i}
        sx={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          bgcolor: 'text.secondary',
          animation: 'chat-typing 1.2s infinite ease-in-out',
          // Staggered, so it reads as one thing thinking rather than three
          // things blinking.
          animationDelay: `${i * 0.16}s`,
        }}
      />
    ))}
  </Stack>
);

ChatTyping.displayName = 'ChatTyping';
export default ChatTyping;
